module.exports = "/assets/4e981cfa59b44c4012b991258937c565.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SA.png
// module id = 1814
// module chunks = 0